import enLang from './entries/en_US'
import jaLang from './entries/ja_JP'

const AppLocale = {
  en: enLang,
  jp: jaLang,
}

export default AppLocale
